import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import Secret from '../../config/secret'

Vue.use(VueGoogleMaps, {
    load: {
        key: Secret.GOOGLE_MAP_KEY,
        libraries: 'places,drawing,geometry', // This is required if you use the Autocomplete plugin,
    }
})


// WEBPACK FOOTER //
// ./src/plugins/googleMap.js